import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { toast } from "sonner";

export default function Footer({ settings }) {
  const [email, setEmail] = useState("");
  const subscribe = (e) => {
    e.preventDefault();
    if (email.includes("@")) {
      toast.success("Εγγραφήκατε στο newsletter!", { description: "Καλωσήρθες στην οικογένεια SKGWEAR." });
      setEmail("");
    }
  };
  return (
    <footer className="bg-[#0A0A0B] border-t border-zinc-800 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <span className="font-display text-2xl font-extrabold tracking-tight">SKG<span className="text-[#FF2E4C]">WEAR</span></span>
            <p className="text-zinc-500 text-sm mt-3 font-mono uppercase tracking-widest">MORE THAN CLOTHING</p>
            <p className="text-zinc-400 text-sm mt-4 max-w-xs">Premium streetwear από τη Θεσσαλονίκη. Clothes for a better you.</p>
            <div className="flex gap-3 mt-5">
              <a href={settings?.instagram || "https://instagram.com/skgwear"} target="_blank" rel="noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-zinc-700 rounded-full hover:bg-[#FF2E4C] hover:border-[#FF2E4C] transition-colors" aria-label="instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={settings?.tiktok || "https://tiktok.com/@skgwear"} target="_blank" rel="noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-zinc-700 rounded-full hover:bg-[#FF2E4C] hover:border-[#FF2E4C] transition-colors font-bold text-xs" aria-label="tiktok">
                TT
              </a>
            </div>
          </div>

          <FooterCol title="SHOP" links={[
            ["Όλα τα προϊόντα", "/shop"], ["New Drop", "/shop?badge=new"],
            ["Best Sellers", "/shop?badge=best_seller"], ["Limited Edition", "/shop?badge=limited"], ["Sale", "/shop?on_sale=1"],
          ]} />
          <FooterCol title="ΒΟΗΘΕΙΑ" links={[
            ["Επικοινωνία", "/contact"], ["Αποστολές", "/legal/shipping"],
            ["Επιστροφές", "/legal/returns"], ["Παρακολούθηση Παραγγελίας", "/account"],
          ]} />
          <div>
            <h4 className="font-display font-bold uppercase tracking-tight mb-4">NEWSLETTER</h4>
            <p className="text-zinc-400 text-sm mb-4">Γίνε ο πρώτος που θα μάθει για νέα drops & προσφορές.</p>
            <form onSubmit={subscribe} className="flex flex-col gap-2">
              <input data-testid="newsletter-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Email σου" className="bg-[#18181C] border border-zinc-700 rounded px-3 py-2.5 text-sm outline-none focus:border-[#FF2E4C]" />
              <button data-testid="newsletter-submit" className="btn-red py-2.5 text-xs font-bold tracking-widest uppercase rounded">ΕΓΓΡΑΦΗ</button>
            </form>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-zinc-600 text-xs">© {new Date().getFullYear()} SKGWEAR. All rights reserved.</p>
          <div className="flex flex-wrap gap-4 text-xs text-zinc-500">
            <Link to="/legal/terms" className="hover:text-white">Όροι Χρήσης</Link>
            <Link to="/legal/privacy" className="hover:text-white">Απόρρητο</Link>
            <Link to="/legal/cookies" className="hover:text-white">Cookies</Link>
            <Link to="/legal/returns" className="hover:text-white">Επιστροφές</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <h4 className="font-display font-bold uppercase tracking-tight mb-4">{title}</h4>
      <ul className="space-y-2.5">
        {links.map(([label, to]) => (
          <li key={label}><Link to={to} className="text-zinc-400 text-sm hover:text-[#FF2E4C] transition-colors">{label}</Link></li>
        ))}
      </ul>
    </div>
  );
}
